export default __webpack_public_path__ + "static/1-27f5bafd226430fb201895609e8cf9e1.png";